import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import type { Option as FieldValue } from '@atlassian/jira-issue-field-project/src/common/types.tsx';
import { ProjectCustomFieldEdit } from '@atlassian/jira-issue-field-project/src/ui/edit/async-project-cf/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '../../common/utils/select/index.tsx';
import type { Props, ProjectFieldConfig } from './types.tsx';
import { validateProjectField, transformDefaultProjectValue } from './utils.tsx';

const ProjectCF = (props: Props) => {
	const {
		fieldId,
		autoCompleteUrl = '',
		fieldProps: { value = null, onChange, id },
		width,
		autoFocus = false,
		// @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
		ariaLabelledBy,
	} = props;

	return (
		<FieldContainer width={width}>
			<ProjectCustomFieldEdit
				fieldId={fieldId}
				value={value}
				onChange={onChange}
				autoFocus={autoFocus}
				autoCompleteUrl={autoCompleteUrl}
				onCloseMenuOnScroll={onCloseMenuOnScroll}
				isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
				fetchSuggestionsOnFocus
				aria-labelledby={ariaLabelledBy}
				{...(fg('async-project-cf-a11y-violations') && {
					fieldId: id || fieldId,
				})}
			/>
		</FieldContainer>
	);
};

export default withFormField({
	validator: validateProjectField,
	transformDefaultValue: transformDefaultProjectValue,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ProjectFieldConfig, Option>, any>'.
})<ProjectFieldConfig, FieldValue>(ProjectCF);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateProjectField } from './utils';
